import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Secciones/Home';
import { Header, Footer } from './Widgets/Widgets';
import { Consultoria, Cobranza} from './Secciones/Servicios';
import { Contacto, ContactoCobranza} from './Secciones/Contacto';
import Desuscripcion from './Secciones/Desuscripcion';
import { AlertaPago } from './Widgets/Widgets';

function App() {
  return (
    <Router>
      <div className="page-wrapper">
        <Header/>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/consultoria-en-desarrollo-organizacional" element={<Consultoria />} />
            <Route path="/cobranza-judicial-y-extrajudicial" element={<Cobranza />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/desuscripcion" element={<Desuscripcion />} />
          </Routes>
        <AlertaPago/>
        <Footer/>
      </div>
    </Router>
  );
}

export default App;
